/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable camelcase */
/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { api } from './config';

export class Address {
  async listState<T>(data: any): Promise<T> {
    return api.post('/oapi/v1/controller/operacao_oapi.php', data);
  }

  async listCityState<T>(data: any): Promise<T> {
    return api.post('/oapi/v1/controller/operacao_oapi.php', data);
  }

  async listCityDestrict<T>(data: any): Promise<T> {
    return api.post('/oapi/v1/controller/operacao_oapi.php', data);
  }

  async listAddress<T>(data: any): Promise<T> {
    return api.post('/oapi/v1/controller/operacao_oapi.php', data);
  }

  async createAddress<T>(data: any): Promise<T> {
    return api.post('/oapi/v1/controller/operacao_oapi.php', data);
  }

  async deleteAddress<T>(data: any): Promise<T> {
    return api.post('/oapi/v1/controller/operacao_oapi.php', data);
  }

  async checkLatLong<T>(data: any): Promise<T> {
    return api.post('/oapi/v1/controller/operacao_oapi.php', data);
  }
}
